import { http } from "helpers/Http";
import {
  IUserAddressAddParams,
  IUserAddressListResponse,
  IUserAddressResponse,
} from "types/Address";

export async function postAddAddress(
  params: IUserAddressAddParams
): Promise<IUserAddressResponse> {
  const url = `address/new`;
  const data = http
    .post(url, {
      user_id: params.user_id,
      type: params.type,
      complete_address: params.complete_address,
      description: params.description,
      number: params.number,
      neighborhood: params.neighborhood,
      city: params.city,
      state: params.state,
      postal_code: params.postal_code,
      lat: params.lat,
      lon: params.lon,
      active: params.active,
      reference_point: params.reference_point,
      additional_info: params.additional_info,
      current_shopping_bag_id: params.current_shopping_bag_id
    })
    .then((response) => response.data);
  return data;
}

export async function fetchAPIAddresses(
  id: number
): Promise<IUserAddressListResponse> {
  const url = `address/${id}`;
  const data = http.get(url).then((response) => response.data);
  return data;
}

export async function postEditAddress(
  params: IUserAddressAddParams
): Promise<IUserAddressResponse> {
  const url = `address/update/${params.id}`;
  const data = http
    .post(url, {
      type: params.type,
      complete_address: params.complete_address,
      description: params.description,
      number: params.number,
      neighborhood: params.neighborhood,
      city: params.city,
      state: params.state,
      postal_code: params.postal_code,
      lat: params.lat,
      lon: params.lon,
      active: params.active,
      user_id: params.user_id,
      reference_point: params.reference_point,
      additional_info: params.additional_info,
      current_shopping_bag_id: params.current_shopping_bag_id
    })
    .then((response) => response.data);
  return data;
}

export async function postRemoveAddress(
    params: IUserAddressAddParams
  ): Promise<IUserAddressResponse> {
    const url = `address/${params.id}?cardapio_web=true`;
    const data = http.delete(url).then((response) => response.data);
    return data;
  }